import { createTheme, type PaletteMode } from "@mui/material";
import { FONT_BODY, FONT_HEADING, FONT_MONO } from "@/constants";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#00236f" },
            secondary: { main: "#505f76" },
            error: { main: "#ba1a1a" },
            background: { default: "#faf8ff", paper: "#ffffff" },
          }
        : {
            primary: { main: "#b6c4ff" },
            secondary: { main: "#b7c8e1" },
            error: { main: "#ffb4ab" },
            background: { default: "#121218", paper: "#1a1b21" },
          }),
    },
    typography: {
      fontFamily: FONT_BODY,
      h1: { fontFamily: FONT_HEADING },
      h2: { fontFamily: FONT_HEADING },
      h3: { fontFamily: FONT_HEADING },
      h4: { fontFamily: FONT_HEADING },
      h5: { fontFamily: FONT_HEADING },
      h6: { fontFamily: FONT_HEADING },
      overline: { fontFamily: FONT_MONO },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
            fontWeight: 600,
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "12px",
            border: "1px solid",
            borderColor: mode === "light" ? "#c5c5d3" : "#444651",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            "&.Mui-selected": {
              backgroundColor: mode === "light" ? "#dce1ff" : "#264191",
              color: mode === "light" ? "#00236f" : "#b6c4ff",
              "&:hover": {
                backgroundColor: mode === "light" ? "#c8ceff" : "#1e3a8a",
              },
            },
          },
        },
      },
    },
  });
}
